@import '../../../global/global.pcss';
@import '../atomic-rating/atomic-rating.pcss';

.max-w-snippet {
  max-width: 30ch;
}
